import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import API_URL from "../config";

const Programs = () => {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/programs`)
      .then((response) => {
        const featuredPrograms = response.data.filter((p) => p.featured);
        setPrograms(featuredPrograms);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Failed to load programs.");
        setLoading(false);
      });
  }, []);

  const SkeletonCard = () => (
    <div className="border rounded-lg shadow-sm p-6 sm:p-8 bg-white animate-pulse space-y-4">
      <div className="h-5 bg-gray-300 rounded w-3/4"></div>
      <div className="h-4 bg-gray-300 rounded w-full"></div>
      <div className="h-4 bg-gray-300 rounded w-2/3"></div>
      <div className="h-4 bg-gray-300 rounded w-1/3 mt-4"></div>
    </div>
  );

  if (loading) {
    return (
      <section className="py-16 sm:py-24 bg-indigo-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16 lg:mb-20">
            <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500 mb-3 sm:mb-4">
              Curriculum
            </p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin mb-6 sm:mb-8">
              AI for <em>Business Value</em>
            </h2>
            <p className="text-sm sm:text-base md:text-lg font-light leading-relaxed max-w-3xl mx-auto text-gray-600">
              We design practical, results-driven programs to help business owners and professionals
              boost productivity, make smarter decisions, and scale with AI.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(3)].map((_, index) => (
              <SkeletonCard key={index} />
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center py-16 sm:py-24 bg-indigo-50 px-6">
        <p className="text-red-600 text-sm sm:text-base">
          Error: {error}
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white text-black py-10 sm:py-20 lg:py-20">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500 mb-3 sm:mb-4">
            Curriculum
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin mb-6 sm:mb-8">
            AI for <em>Business Value</em>
          </h2>
          <p className="text-sm sm:text-base md:text-lg font-light leading-relaxed max-w-3xl mx-auto text-gray-600">
            We design practical, results-driven programs to help business owners and professionals
            boost productivity, make smarter decisions, and scale with AI.
          </p>
        </div>

        {/* Program cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {programs.length === 0 ? (
            <p className="text-center col-span-full text-gray-500 text-sm sm:text-base">
              No featured programs available at the moment.
            </p>
          ) : (
            programs.map((program) => (
              <Link to={`/programs/${program.slug}`} key={program.id}>
                <div className="group border border-gray-200 p-6 sm:p-8 hover:border-black transition-all duration-300 h-full">
                  <h3 className="text-xl sm:text-2xl font-light mb-3 sm:mb-4 tracking-wide">
                    {program.title}
                  </h3>
                  <p className="text-gray-600 font-light mb-6 sm:mb-8 leading-relaxed text-sm sm:text-base">
                    {program.subtitle}
                  </p>
                  <button className="text-[11px] sm:text-sm tracking-[0.2em] uppercase text-gray-500 group-hover:text-black transition-colors">
                    Learn More →
                  </button>
                </div>
              </Link>
            ))
          )}
        </div>

        {/* More Programs CTA */}
        <div className="text-center mt-10 sm:mt-12">
          <Link to="/programs">
            <button className="border border-gray-300 px-10 sm:px-12 py-3.5 sm:py-4 text-[11px] sm:text-sm tracking-[0.2em] uppercase text-gray-600 hover:border-black hover:text-black transition-all duration-300">
              More Programs
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Programs;
